import { useState, useEffect } from 'react';
import { getAdminStats } from '../../api/adminService';
import { Link } from 'react-router-dom';
import AppLayout from '../../components/AppLayout';
import '../../styles/auth.scss';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const { data } = await getAdminStats();
        setStats(data.stats);
      } catch (error) {
        console.error('Failed to load stats:', error);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, []);

  if (loading) {
    return (
      <AppLayout pageBadge="Admin Dashboard">
        <div className="admin-dashboard">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading dashboard...</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  const cards = stats
    ? [
        { label: 'Total Users', value: stats.total, gradient: 'primary', icon: '👥' },
        { label: 'Admins', value: stats.admins, gradient: 'red', icon: '⚡' },
        { label: 'Analysts', value: stats.analysts, gradient: 'green', icon: '📊' },
        { label: 'Viewers', value: stats.viewers, gradient: 'blue', icon: '👁️' },
        { label: 'Active', value: stats.active, gradient: 'green', icon: '✅' },
        { label: 'Verified', value: stats.verified, gradient: 'blue', icon: '✉️' },
      ]
    : [];

  return (
    <AppLayout pageBadge="Admin Dashboard">
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>⚙️ Admin Dashboard</h1>
        <p>Manage users and system settings</p>
      </div>

      <div className="stats-grid">
        {cards.map((card, index) => (
          <div key={index} className={`stat-card stat-card-${card.gradient}`}>
            <div className="stat-icon">{card.icon}</div>
            <div className="stat-content">
              <div className="stat-value">{card.value}</div>
              <div className="stat-label">{card.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="admin-actions">
        <Link to="/admin/users" className="btn-auth">
          Manage Users
        </Link>
        <Link to="/admin/db-management" className="btn-auth" style={{ marginLeft: '1rem', background: 'linear-gradient(135deg, #ef4444, #dc2626)' }}>
          🗄️ DB Management
        </Link>
      </div>
    </div>
    </AppLayout>
  );
};

export default AdminDashboard;
